import React, { ReactNode } from "react";

import clsx from "clsx";

interface CardProps {
  children: ReactNode;
  containerClassName?: string;
  bodyClassName?: string;
  title?: string;
  labelId?: string;
  titleRightContent?: ReactNode;
}

export default function Card({
  children,
  containerClassName,
  bodyClassName,
  title,
  labelId,
  titleRightContent,
}: CardProps) {
  return (
    <div
      className={containerClassName}
      aria-labelledby={`${labelId ?? "card"}-title`}
    >
      {(title || titleRightContent) && (
        <div className="bg-white shadow rounded-lg">
          <div
            className={clsx(
              titleRightContent !== undefined ? "py-4 pl-4 pr-3.5" : "py-5 px-4",
              "flex justify-between items-center"
            )}
          >
            {title && (
              <h2
                id={`${labelId ?? "card"}-title`}
                className="text-lg font-stick font-medium leading-6 text-gray-900"
              >
                {title}
              </h2>
            )}
            {titleRightContent && titleRightContent}
          </div>
          <div className={`border-t border-gray-200 ${bodyClassName}`}>
            {children}
          </div>
        </div>
      )}
      {!title && (
        <div className="bg-white shadow rounded-lg">
          <div className={`${bodyClassName}`}>{children}</div>
        </div>
      )}
    </div>
  );
}
